import api from "../../utils/api";
import { LOGOUT } from "../types";

export const mine = () => async (dispatch) => {
    try {
        const res = await api.get("/surveys/invites/me");
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) {
            dispatch({ type: LOGOUT });
        }

        return { success: false, items: [] };
    }
};
